/* Melzer new design – homepage behaviour */
(function(){if(!document.querySelector('.nd'))return;

(function(){

  var root=document.documentElement;



  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vh=innerHeight;
  if(!reduce&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('pending');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.rise').forEach(function(el,i){
      var r=el.getBoundingClientRect();
      if(r.top>vh*0.92){el.classList.add('pending');el.style.transitionDelay=(el.parentNode.id==='dlist'?(i%12)*40:0)+'ms';io.observe(el)}
    });
  }

  
  var rail=document.getElementById('collection'),track=document.getElementById('track');
  var drifters=[].slice.call(document.querySelectorAll('[data-speed]'));
  var zoomers=[].slice.call(document.querySelectorAll('.sp .ph img'));
  function cl(v){return v<0?0:v>1?1:v}
  var ticking=false;
  function tick(){
    ticking=false;
    vh=innerHeight;
  }

  var fxEls=[].slice.call(document.querySelectorAll('[data-fx]'));
  var countEl=document.getElementById('count');
  function initFx(){
  if(!reduce&&'IntersectionObserver' in window){
    fxEls.forEach(function(el){
      var sib=[].slice.call(el.parentNode.children).indexOf(el);
      var d=(sib%4)*90+'ms';el.style.transitionDelay=d;el.style.animationDelay=d;
      el.classList.add('fx-pre');
    });
    var fio=new IntersectionObserver(function(es){es.forEach(function(e){
      var el=e.target;
      if(e.isIntersecting){el.classList.remove('fx-pre');el.classList.add('fx-in');fio.unobserve(el)}
    })},{threshold:0.18});
    fxEls.forEach(function(el){fio.observe(el)});
    if(countEl){
      var cio=new IntersectionObserver(function(es){if(es[0].isIntersecting){var t0=performance.now();(function step(){var k=Math.min(1,(performance.now()-t0)/1400);countEl.textContent=Math.round(30*(1-Math.pow(1-k,3)));if(k<1)requestAnimationFrame(step)})()}},{threshold:0.4});
      cio.observe(countEl);
    }
  }
  }
  initFx();
  function runFx(){}
  (function(){
    var tiles=[].slice.call(document.querySelectorAll('.draft4 .tile:not(.mood)'));
    if(!tiles.length||matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
    tiles.forEach(function(el){el.classList.add('pop-wait')});
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('pop-in');io.unobserve(e.target)}})},{threshold:0.2,rootMargin:'0px 0px -8% 0px'});
    tiles.forEach(function(el){io.observe(el)});
  })();

  (function(){
    var v=document.getElementById('studioVid');if(!v)return;
    var still=matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(still||!('IntersectionObserver' in window))return;
    new IntersectionObserver(function(es){
      if(es[0].isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause();
    },{threshold:0.25}).observe(v);
  })();

  (function(){
    var touch=matchMedia('(hover: none)').matches,rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tiles=[].slice.call(document.querySelectorAll('.tile.gallery')).filter(function(g){return g.querySelectorAll('.fr').length>1});
    function sign(tr){return getComputedStyle(tr).direction==='rtl'?-1:1}
    tiles.forEach(function(g){
      var tr=g.querySelector('.gtrack'),dt=[].slice.call(g.querySelectorAll('.gdots i')),n=g.querySelectorAll('.fr').length;g._timer=null;g._hold=0;
      function cur(){return Math.round(Math.abs(tr.scrollLeft)/tr.clientWidth)}
      function go(k){if(k===0&&cur()>0){tr.style.opacity=0;setTimeout(function(){tr.style.scrollBehavior='auto';tr.scrollLeft=0;tr.style.scrollBehavior='';tr.style.opacity=1},350);return}
        tr.scrollTo({left:sign(tr)*k*tr.clientWidth,behavior:rm?'auto':'smooth'})}
      g._step=function(){if(Date.now()<g._hold)return;go((cur()+1)%n)};
      g._start=function(ms){if(g._timer)return;g.classList.add('cycling');[].forEach.call(g.querySelectorAll('img'),function(e){e.loading='eager'});g._timer=setInterval(g._step,ms)};
      g._stop=function(){clearInterval(g._timer);g._timer=null;g.classList.remove('cycling')};
      tr.addEventListener('scroll',function(){var k=cur();dt.forEach(function(e,j){e.classList.toggle('on',j===k)})},{passive:true});
      ['pointerdown','touchstart','wheel'].forEach(function(ev){tr.addEventListener(ev,function(){g._hold=Date.now()+5000},{passive:true})});
      if(!touch){g.addEventListener('mouseenter',function(){g._hold=0;g._step();g._start(700)});g.addEventListener('mouseleave',g._stop);
        g.addEventListener('focus',function(){g._start(700)});g.addEventListener('blur',g._stop)}
    });
    if(!touch)return;
    var active=null,raf=0;
    function pick(){raf=0;var mid=innerHeight/2,best=null,bd=1e9;tiles.forEach(function(t){var r=t.getBoundingClientRect();if(r.bottom<innerHeight*.2||r.top>innerHeight*.8)return;var d=Math.abs((r.top+r.bottom)/2-mid);if(d<bd){bd=d;best=t}});
      if(best===active)return;if(active)active._stop();active=best;if(active)active._start(2200)}
    addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(pick)},{passive:true});addEventListener('resize',pick);pick();
  })();

  (function(){
    var w=document.getElementById('trackWrap'),pv=document.getElementById('railPrev'),nx=document.getElementById('railNext');if(!w)return;
    var GAP=16;
    function fit(){var W=w.clientWidth,min=innerWidth>760?230:115,n=Math.max(1,Math.floor((W+GAP)/(min+GAP)));var cw=(W-GAP*(n-1))/n;[].slice.call(w.querySelectorAll('.card')).forEach(function(c){c.style.width=cw+'px'});w._n=n;w._cw=cw}
    fit();addEventListener('resize',fit);
    function step(){return (w._cw+GAP)*Math.min(2,w._n)}
    function dirSign(){return root.dir==='rtl'?-1:1}
    function upd(){var max=w.scrollWidth-w.clientWidth,pos=Math.abs(w.scrollLeft);pv.disabled=pos<4;nx.disabled=pos>max-4}
    pv.addEventListener('click',function(){w.scrollBy({left:-step()*dirSign(),behavior:'smooth'})});
    nx.addEventListener('click',function(){w.scrollBy({left:step()*dirSign(),behavior:'smooth'})});
    w.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);
    upd();
  })();

  (function(){
    var touch=matchMedia('(hover: none)').matches;
    [].slice.call(document.querySelectorAll('.switch')).forEach(function(t){
      var hov=false,mid=false;
      function set(){t.classList.toggle('lit',hov||mid)}
      t.addEventListener('mouseenter',function(){hov=true;set()});
      t.addEventListener('mouseleave',function(){hov=false;set()});
      t.addEventListener('focus',function(){hov=true;set()});
      t.addEventListener('blur',function(){hov=false;set()});
      if(touch&&'IntersectionObserver' in window){new IntersectionObserver(function(es){mid=es[0].isIntersecting;set()},{rootMargin:'-40% 0px -40% 0px'}).observe(t)}
    });
  })();

  var tw=document.querySelector('.track-wrap');if(tw)tw.addEventListener('scroll',req,{passive:true});
  function req(){if(!ticking){ticking=true;requestAnimationFrame(tick)}}
  addEventListener('scroll',req,{passive:true});
  addEventListener('resize',req);
  tick();
})();

})();
